<template>
  <ListaClientes />
</template>

<script>
import ListaClientes from '@/components/Clientes/ListaClientes.vue'
export default {
  name: 'ClientesView',
  components: { ListaClientes }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/ClientesView.vue